export const facebookAppId = () => {
  switch (import.meta.env.VITE_ENV) {
    case 'production':
      return import.meta.env.VITE_FB_APP_ID_PROD;
    case 'staging':
      return import.meta.env.VITE_FB_APP_ID_STAGING;
    default:
      return import.meta.env.VITE_FB_APP_ID;
  }
};
